import React, { useContext } from 'react';
import './Results.scss';
import { layoutContext } from '../CODBGame';
import content from '../../data/content';
import { Button } from 'carbon-components-react';
import { ArrowRight20, Restart16 } from '@carbon/icons-react';
import { Scenario } from '../../data/constants';
import PublicImage from 'src/common/components/PublicImage';

interface resultsProps {
  contents: any;
}

const Results = (resultsProps: resultsProps) => {
  const { contents } = resultsProps;
  const { selectedItems } = useContext(layoutContext);
  const parentClass = 'codb-game__results';
  const selectedItemsArray = Object.values(selectedItems);
  const {
    setCurrentScenario,
    setSelectedItems,
    setWatsonButton,
    setRefreshclicked,
  } = useContext(layoutContext);

  const handleReset = () => {
    setCurrentScenario(Scenario.introduction);
    setSelectedItems({});
    setRefreshclicked(true);
    setWatsonButton(false);
  };

  const resultCalc = () => {
    let countYes = 0;
    let countNo = 0;
    let resultObject = {
      title: '',
      subtitle: '',
      imageName: '',
      countYes: 0,
      countNo: 0,
    };
    selectedItemsArray.forEach(
      (item: any) => item.correctAnswer === 1 && countYes++,
    );
    selectedItemsArray.forEach(
      (item: any) => item.correctAnswer === 0 && countNo++,
    );
    if (countYes >= 5) {
      resultObject = {
        title: '',
        subtitle: 'resultsSubtitleGreen',
        imageName: 'positive',
        countYes: countYes,
        countNo: countNo,
      };
    } else if (countYes <= 2 && countNo >= 2) {
      resultObject = {
        title: '',
        subtitle: 'resultsSubtitleRed',
        imageName: 'negative',
        countYes: countYes,
        countNo: countNo,
      };
    } else {
      resultObject = {
        title: 'resultsTitle',
        subtitle: 'resultsSubtitleYellow',
        imageName: 'neutral',
        countYes: countYes,
        countNo: countNo,
      };
    }
    return resultObject;
  };
  const resultObject = resultCalc();

  const w = window.innerWidth;
  const setImageName = () => {
    let str = '';
    if (w <= 500) {
      str = 'background-mobile';
    } else {
      str = 'background-1';
    }
    return str;
  };
  const imageName = setImageName();
  return (
    <div
      className={parentClass}
      style={{
        backgroundImage: `url("${process.env.PUBLIC_ASSETS_URL}/codb-game/images/${imageName}-final-results-codb-game.png")`,
      }}
    >
      <div className="bx--col-lg-10">
        <div className={`${parentClass}-title`}>
          <h2 className={`${parentClass}-title-content`}>
            {content.results.resultsTitle}
          </h2>
        </div>
        <div className={`${parentClass}-description`}>
          <p className={`${parentClass}-description-content`}>
            {content.results.resultsDescription01} {resultObject.countYes}{' '}
            {content.results.resultsDescription02}{' '}
            {resultObject.countNo + resultObject.countYes}{' '}
            {content.results.resultsDescription03}
          </p>
          <p className={`${parentClass}-description-content`}>
            {content.results.resultsDescription04}
          </p>
        </div>
      </div>
      <div className="codb-game__restart">
        <Button
          kind="tertiary"
          className="codb-game__question-cta-previous"
          onClick={handleReset}
        >
          <Restart16 className="codb-game__question-cta-previous-restart" />
        </Button>
      </div>
      <div className={`${parentClass}-button`}>
        <Button
          className={`${parentClass}-button-buttonResults`}
          href="https://www.ibm.com/account/reg/signup?formid=urx-52913"
        >
          {content.results.resultsDescriptionButton}
          <ArrowRight20
            className={`${parentClass}-button-buttonResults-icon`}
          />
        </Button>
      </div>
    </div>
  );
};

export default Results;
